<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_st1110"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{ checkMethod }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      class="mytable-footer"
      :footer-method="footerMethod"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="充值人"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入充值人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPhone"
          title="充值人电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userPhone"
            placeholder="请输入充值人电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPartyType"
          title="角色"
          min-width="150"
          sortable
          :formatter="formatterAuthStatus"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="充值时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="optionsPicker"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidItem"
          title="充值类型"
          min-width="150"
          sortable
          :formatter="formatterStatus"
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidAmount"
          title="充值金额"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.paidAmount"
            placeholder="请输入金额"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="paidRemark"
          title="备注"
          min-width="150"
          sortable
        />
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
  </div>
</template>
<script>
import { rechargeRecord } from "@/api/invoice";

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      transferTimeRange: "",
      applyDateRange: "",
      listQuery: {
        gmtCreatedRange: "",
        userPartyType: "",
        paidAmount: "",
        userPhone: "",
        userName: "",
        paidItem: "",
        status: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      Pagingconf: [],
      sumObject: {},
      options: [{ value: "0", label: "余额" }, { value: "1", label: "保证金" }],
      optiones: [
        { value: 0, label: "实际承运人" },
        { value: 1, label: "托运人" }
      ]
    };
  },
  watch: {
    $route(to, from) {
      const v = to.query.todo;
      if (v) {
        this.listQuery.status = 0;
      } else {
        this.listQuery.status = "";
      }
      this.findList();
    }
  },
  created() {
    const v = this.$route.query.todo;
    if (v) {
      this.listQuery.status = 0;
    }
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        rechargeRecord(this.listQuery).then(response => {
          //console.log(response)
          this.tableData = response.data.records;
          response.data.total > 10000
            ? (this.Pagingconf = [20, 30, 50, 100, 10000])
            : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 选框
    checkMethod({ row }) {
      return row.status === 0 || row.status === 3;
    },
    // 状态
    formatterAuthStatus({ cellValue }) {
      const item = this.optiones.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      const item = this.options.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "";
          }
          if (column.property === "money") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "";
        })
      ];
    }
  }
};
</script>
